<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div class="title">选择服务人员</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="padding: 10px;">

        <div>
          <div style="float:right;">

            <el-select size="mini" v-model="businessCode" placeholder="请选择商家" style="margin-right:5px">
              <el-option
                  v-for="item in arr_business"
                  :key="item.businessCode"
                  :label="item.name"
                  :value="item.businessCode">
              </el-option>
            </el-select>

            <el-input size="mini" placeholder="输入姓名" v-model="name" clearable style="margin:0 5px;width:120px"></el-input>
            <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">查询</el-button>
          </div>
          <div style="clear:both;"></div>
        </div>


        <div style="height: 10px;"></div>

        <el-table class="table" size="mini" :data="tableData" v-loading="loading" border :height="300">
          <el-table-column label="姓名" prop="name" width="100"></el-table-column>
          <el-table-column label="手机号" prop="phone"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click.native.prevent="handleSelect(scope.$index, scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="page" style="padding: 5px;">
          <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination small
                           background
                           layout="prev, pager, next"
                           :total="totalItems"
                           :page-size="20"
                           :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getGovernmentCode, getStaffCode} from "@/utils/auth";

export default {
  name: 'ElderlyGov',
  data() {
    return {

      loading: false,


      arr_business:[],
      businessCode:'',

      name:'',

      tableData:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      th:this.$store.state.tableHeight,
    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th=val
    },
  },
  methods: {
    init(){
      this.currentPage = 1;
      this.getBusiness();
    },
    closeSelf() {
      this.$emit("closeServe");
    },

    getBusiness(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/GovList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          governmentCode: getGovernmentCode(),
          businessType:-1,
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.arr_business = response.data.data;
              if(this.arr_business.length>0){
                this.businessCode = this.arr_business[0].businessCode;
                this.getList();
              }

            }else if(response.data.error === 1){
              this.$message.error(response.data.message)
            }

          }
      )

    },



    handleSelect(index, row) {
      this.$emit("setServe",row);
      this.closeSelf();
    },
    getTime(row,index,column){
      return timefilters(column)
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){

      if(isSearch)this.currentPage = 1;

      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Serve/GovPageBus",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          businessCode:this.businessCode,
          name: this.name,
          status: -1,
        }
      }).then((response) => {
        this.loading = false;

        if (response.data.error == 0) {
          this.tableData=response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }

      })
    },


  }
}


</script>

<style lang="scss" scoped>

</style>
